export const ctaTypeApiCall = 'apiCall';
export const ctaTypeNavigation = 'navigation';

export type NavigationCta = {
  ctaType: typeof ctaTypeNavigation;
  navigationUrl: string;
};

export type ApiCallCta = {
  ctaType: typeof ctaTypeApiCall;
  apiEndpoint: string;
  apiMethod: string;
  apiPayload?: Record<string, unknown>;
  successNotification: string;
  errorNotification: string;
};

export type CtaConfig = NavigationCta | ApiCallCta;
